import { render, staticRenderFns } from "./BerthMonitoring.vue?vue&type=template&id=4da6d5dc"
import script from "./BerthMonitoring.vue?vue&type=script&lang=js"
export * from "./BerthMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports